export function validateScalingIn(data) {
  if (data.breakPrices === undefined || data.breakPrices === null) {
    return [false, 'No break prices provided.'];
  }
  if (data.quantityBasisValues === undefined) {
    return [false, 'No quantity basis values provided.'];
  }
  if (
    data.breakPrices !== undefined &&
    data.quantityBasisValues !== undefined
  ) {
    if (data.breakPrices.length !== data.quantityBasisValues.length) {
      return [
        false,
        'You must provide equal numbers of break prices and quantity basis values.',
      ];
    }
  }
  return [true, ''];
}
